import { RootState } from '@reducers';
import { UserRoles } from '@models/UserProfile';

export const selectAuth = (state: RootState) => state.authReducer;
export const selectCurrentUser = (state: RootState) => selectAuth(state)?.currentUser;
export const selectIsFrontline = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Frontline;
export const selectIsCustomer = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Customer;
export const selectIsInsurer = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Insurer;
export const selectIsCompany = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Company;
export const selectIsHospital = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Hospital;
export const selectIsProcessing = (state: RootState) => selectCurrentUser(state)?.role === UserRoles.Processing;
